$(document).ready(function () {

    setTimeout(function(){
        $(".js-shave-heading").shave(78);
        $(".js-shave-p").shave(100);
        $(".js-shave-heading-big").shave(120);
        $(".js-shave-p-big").shave(100);
    }, 10);

    $(document).on('click', '.js-scroll', function (event) {
        event.preventDefault();
        var Anchor = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(Anchor).offset().top - 80
        }, 1000);
    })

    $("body").on("submit", ".js-ajax-form", function () {

        var $this = $(this);
        var $args = $this.serializeArray();
        var $sendDataTo = $this.attr("action");
        var $target = $this.data("target");
        var $callback = function (msg) {
            $($target).html(msg);
        };

        // disabled formularovych prvku
        $("input, textarea, select", $this).attr("disabled", true);

        // odeslani ajax pozadavku
        $.post($sendDataTo, $args, $callback);

        return false;
    });

    $(".js-recaptcha-newsletter").hide();
    $(document).on('click', ".js-trigger-newsletter", function () {
        $(".js-recaptcha-newsletter").show(100);
    });

    // top bar
    $(document).on("click", ".top-bar-close", function () {
        let $topBar = $(".top-bar");
        let $header = $(".header");
        $topBar.remove();
        $header.css("top", "auto");
        $.ajax({url: "/ajax-topbar.php"});
    });

    $(document).scroll(function() {
        setHeaderHeight();
    });
    $(window).resize(function() {
        setHeaderHeight();
    });

    function setHeaderHeight() {
        let $topBar = $(".top-bar");

        if ($topBar.length === 0) {
            return;
        }
        let $header = $(".header");

        if ($(document).scrollTop() > 0) {
            $header.css("top", $topBar.height() + "px");
        } else {
            $header.css("top", "auto");
        }
    }

});

